import { t } from '../i18n';

// Libellé COSMÉTIQUE du bandeau de phase du chat, dérivé du nombre de tours utilisateur.
// L'entretien commence toujours par la présentation (certain) ; ensuite c'est le prompt IA qui
// pilote les questions, donc on reste sur un libellé neutre pour ne pas contredire le recruteur.
const PRESENTATION_TURNS = 2;

export function interviewPhaseLabel(userTurns: number): string {
  return userTurns < PRESENTATION_TURNS ? t('interview.phasePresentation') : t('interview.phaseOngoing');
}
